import { createI18n } from 'vue-i18n';
import axios from 'axios'; // 引入 axios
import en from './locales/en.json';
import zh from './locales/zh.json';

const messages = {
  en,
  zh,
};

// 判断是否为中文地区
const isChineseRegion = (countryCode) => {
  const chineseRegions = ['CN', 'HK', 'TW', 'MO']; // 中国、香港、台湾、澳门的地区代码
  return chineseRegions.includes(countryCode);
};

// 获取用户地理位置并设置默认语言
const getDefaultLocale = async () => {
  // 检查本地缓存
  const cachedCountryCode = localStorage.getItem('userCountryCode');

  if (cachedCountryCode) {
    return cachedCountryCode;
  }
  try {
    const response = await axios.get('https://ipapi.co/json/');
    const countryCode = response.data.country;

    // 缓存国家代码
    localStorage.setItem('userCountryCode', isChineseRegion(countryCode) ? 'zh' : 'en');

    return isChineseRegion(countryCode) ? 'zh' : 'en';
  } catch (error) {
    console.error('Failed to fetch location data:', error);
    return 'en';
  }
};

// 创建 i18n 实例
const setupI18n = async () => {
  const locale = await getDefaultLocale() || 'en'; // 获取默认语言

  return createI18n({
    locale, // 设置默认语言
    fallbackLocale: 'en', // 回退语言
    messages,
  });
};

// 导出 i18n 实例
export default setupI18n;